import React from "react";

import NavigationContext from "../contexts/navigation/navigation-context";

const useNavigation = () => React.useContext(NavigationContext);

export default useNavigation;
